import { ApaduaLegacyAPI } from 'src/apis/ApaduaLegacyAPI';

export class QuoteDocumentLegacyAPI extends ApaduaLegacyAPI {
    resource: string = 'api/quote-document-types/';

    getDocumentTypes(): Promise<any> {
        return this.get('') as any;
    }
}
